import styled from 'styled-components'
import { Pagination as PaginationComponent } from '@sainsburys-tech/bolt'

export const FindabilityPagination = styled(PaginationComponent)`
  padding: 15px 0;
  margin: 0 15px;

  @media screen and (min-width: ${props => props.theme.screen_sm_min}) {
    padding: 0;
    margin-top: 15px;
    margin-bottom: 30px;
  }

  @media screen and (min-width: ${props => props.theme.screen_lg_min}) {
    margin: 15px 0 30px;
  }
`
